import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import theme from "./theme";

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: "light",
        themes: {
            light: theme
        }
    },
    defaults: {
        VTextField: {
            variant: "underlined",
            color: "primary"
        },
        VSelect: {
            variant: "underlined",
            color: "primary"
        },
        VAutocomplete: {
            variant: "underlined",
            color: "primary"
        },
        VSwitch: {
            color: "primary"
        },
        VCheckbox: {
            color: "primary"
        },
        VDatePicker: {
            color: "primary"
        },
        VProgressLinear: {
            color: "primary"
        },
        VTabs: {
            color: "primary"
        },
        VTextarea: {
            color: "primary"
        },
        VBreadcrumbs: {
            color: "primary"
        }
    }
});
